// extracted by mini-css-extract-plugin
var _1 = "webpack-containers-Extraction-StudyList-RefreshCachedStatus-module__loading";
export { _1 as "loading" }
